module.exports = __webpack_public_path__ + "5cb8fe2ae83ec48d271455fc4e14c021.jpg";